module.exports = __webpack_public_path__ + "img/gc.0fbea495.svg";